module.exports = __webpack_public_path__ + "img/neighbor-2-image-old.540e3f3e.jpg";